<div class="modal fade show" tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">{{"users.Signature" | translate}}</h4>

        <button type="button" class="close" aria-label="Close" (click)="cancelPop.emit()">
          <span>&times;</span>
        </button>
      </div>

      <div class="modal-body" id="signatureDialog">

        <div>
          <div class="form-group">
            <label class="mb-2">{{ 'users.Draw your signature' | translate }}</label>

            <div class="signature-pad-container">

              <div *ngIf="signature">
                <img width="100%" [src]="'data:image/png;base64,' + signature" alt="">
                <button class="btn" (click)="signature = ''">x</button>
              </div>

              <div [hidden]="signature" *ngIf="signaturePadOptions">
                <signature-pad [options]="signaturePadOptions"
                  (onBeginEvent)="drawStart()"
                  (onEndEvent)="drawComplete()">
                </signature-pad>
                <button class="btn" *ngIf="signaturePad" [hidden]="signaturePad.isEmpty()"
                  (click)="signaturePad.clear()">x</button>
              </div>

            </div>

          </div>

          <div class="form-group">
            <label class="mb-2">{{ 'group.or' | translate }} {{ 'users.Upload your signature' | translate }}</label>
            <!-- [showFilesInfo]="true" -->
              <app-file-manager
                [files]='files'
                [managerIndex]='456'
                [maxSize]='1'
                [maxFiles]="1"
                [isSubmitted]="isSubmited"
                [allowedExt]="['png', 'PNG', 'jpg', 'jpeg']"
                (selectedFiles)="files = $event"></app-file-manager>
          </div>

          <!-- <p class="has-error" *ngIf="isSubmited && signaturePad?.isEmpty() && !files.length">
            {{'meetings.Required' | translate}}
          </p> -->


          <div class="modal-btns mt-5">
            <button type="reset" class="close closebtn" (click)="cancelPop.emit()">
              {{ 'swalMsg.cancel' | translate }}
            </button>
            <button mat-raised-button class="btn customBtn px-4" (click)="save()" [disabled]="loading"
              [ngClass]="{ 'loading': loading}">
              {{"group.save" | translate}}
            </button>
          </div>
        </div>

      </div>

    </div>
  </div>
</div>
